import React from 'react';
import { Grid, Icon, Section } from '../../shared';
import { NoGridData } from '../../shared/grid-no-data/no-grid-data';
import './applicant-table.scss';
export var ApplicantTable = function (_a) {
    var changeMainApplicant = _a.changeMainApplicant, selectFunction = _a.selectFunction, applicantList = _a.applicantList, mainApplicantId = _a.mainApplicantId;
    var columns = [
        {
            id: 'firstName',
            description: 'First name',
        },
        {
            id: 'surname',
            description: 'Last name',
        },
        {
            id: 'isMain',
            description: 'Main applicant',
            render: function (column, row) {
                return (React.createElement("input", { type: "radio", name: "isPrimary", checked: row.id.toString() == mainApplicantId, onChange: changeMainApplicant, "data-value": row.id }));
            },
        },
        {
            id: 'id',
            description: 'Remove',
            sort: false,
            render: function (column, row) {
                return (React.createElement("button", { type: "button", className: "c-btn c-btn--close", onClick: selectFunction, "data-value": row.id },
                    React.createElement(Icon, { name: "close" }),
                    React.createElement("span", { className: "u-hidden-visually" }, "Remove client")));
            },
        },
    ];
    return (React.createElement(Section, { title: "Selected Clients", className: "c-applicant-table" },
        React.createElement(Grid, { rowData: applicantList, columns: columns, noRowsMessage: React.createElement(NoGridData, { image: "no-applicants", message: "Select a client from your existing clients" }), showHeaders: applicantList && applicantList.length > 0 })));
};
